<template>
  <div class="procedures container-fluid pb-5">
    <!-- head component -->
    <div class="head-program text-center m-5">
      <h1>
        Step by step belajar<br />
        di Intelligo
      </h1>
    </div>
    <!-- body component -->
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="row_regis row align-items-center justify-content-end">
            <div class="div_regis col-md-10 bg-white p-4 me-5">
              <h1>Registrasi dan login</h1>
              <p class="text-muted">
                Sobat inteligo bisa melakukan pendaftara akun terlebih dahulu
                dan apabila sudah memiliki akun maka bisa langsung login ke
                halaman utama
              </p>
              <img src="../assets/rectangle2708.png" alt="" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="div_email col-md-5 bg-white p-2 pt-0 rounded-3 shadow">
              <form>
                <label
                  for="exampleFormControlInput1"
                  class="form-label text-muted"
                  >Create your email address</label
                >
                <div class="d-flex input_email">
                  <input
                    type="email"
                    class="form-control bg-white"
                    id="exampleFormControlInput1"
                    value="Intelligoid@gmail.com"
                    disabled
                    readonly
                  />
                  <img src="../assets/centang-biru.png" alt="" />
                </div>
              </form>
            </div>
          </div>
          <div class="procedures_1 justify-content-center row">
            <img src="../assets/procedures_1.png" alt="procedures 1" />
          </div>
          <div class="row justify-content-end">
            <div
              class="div_password col-md-5 bg-white p-2 pt-0 rounded-3 shadow"
            >
              <form>
                <label
                  for="exampleFormControlInput2"
                  class="form-label text-muted"
                  >Create your password</label
                >
                <div class="d-flex input_email">
                  <input
                    type="password"
                    class="form-control bg-white"
                    id="exampleFormControlInput1"
                    value="****************"
                    disabled
                    readonly
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-5">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="div_data_science p-2 ms-4 rounded-3 shadow d-flex">
              <img src="../assets/icon_data_science.png" alt="" class="me-2" />
              <div class="div_content_data_science pt-1">
                <p>Data Science</p>
                <a href="">Our Program</a>
              </div>
            </div>
          </div>
          <div class="procedures_2 justify-content-center row">
            <img src="../assets/procedures_2.png" alt="procedures 2" />
          </div>
          <div class="row justify-content-end">
            <div class="div_web p-2 rounded-3 shadow d-flex">
              <img src="../assets/icon_web.png" alt="" class="me-2" />
              <div class="div_content_web pt-1">
                <p>Web Development</p>
                <a href="">Our Program</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row_kelas row align-items-center justify-content-end">
            <div class="div_kelas col-md-10 bg-white p-4 me-5">
              <h1>Pilih Kelas Favorit</h1>
              <p class="text-muted">
                Sobat inteligo bisa melakukan pendaftaran akun terlebih dahulu
                dan apabila sudah memiliki akun maka bisa langsung login ke
                halaman utama
              </p>
              <img src="../assets/rectangle2708.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="container">
        <div id="row3">
          <div id="info3">
            <h3>{{ judul3 }}</h3>
            <p>{{ isi3 }}</p>
            <hr size="2px" width="129px" color="#FF865D" />
          </div>
          <div id="ilustration3">
            <img src="../assets/gambar3.png" />
            <div id="ebanking">
              <div><img src="../assets/ebanking.png" /></div>
              <p>{{ ebanking }}</p>
            </div>
            <div id="transfer">
              <div><img src="../assets/transfer.png" /></div>
              <p>{{ transfer }}</p>
            </div>
            <div id="datascience">
              <div><img src="../assets/dollar.png" /></div>
              <h5>{{ hargadatascience }}</h5>
              <p>{{ datascience }}</p>
            </div>
            <div id="webdev">
              <div><img src="../assets/dollar.png" /></div>
              <h5>{{ hargawebdev }}</h5>
              <p>{{ webdev }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div id="row4">
          <div id="ilustration4">
            <img src="../assets/gambar4.png" />
          </div>
          <div id="info4">
            <h3>{{ judul4 }}</h3>
            <p>{{ isi4 }}</p>
            <hr size="2px" width="129px" color="#FF865D" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProceduresForUse",
  props: {
    judul3: String,
    isi3: String,
    ebanking: String,
    transfer: String,
    hargadatascience: String,
    datascience: String,
    hargawebdev: String,
    webdev: String,
    judul4: String,
    isi4: String,
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@400;500&display=swap");

/* * {
    border: ;
} */

.row_regis,
.row_kelas {
  height: 100%;
}
.div_regis,
.div_kelas {
  border: 1px solid rgba(255, 134, 93, 0.4);
  border-radius: 28px;
}
.div_regis > h1,
.div_kelas > h1 {
  font-size: 28px !important;
  font-weight: 600;
  color: #023047;
}
.div_regis > p,
.div_kelas > p {
  font-size: 16px !important;
}
.div_data_science {
  background: #feecd7;
  width: 162px !important;
}
.div_web {
  background: #f9ffe9;
  width: 192px !important;
}
.div_data_science > img,
.div_web > img {
  height: 40px !important;
  align-items: center;
}
.div_content_data_science > p,
.div_content_web > p {
  font-size: 12px !important;
  margin-bottom: -7px !important
  ;
}
.div_content_data_science > a {
  font-size: 10px !important;
  color: #ff865d;
}
.div_content_web > a {
  font-size: 10px !important;
  color: #7cd11b;
}
.procedures {
  background-image: url("../assets/background-procedures.png");
}
.procedures_1 > img {
  width: 372px !important;
}
.procedures_2 > img {
  width: 471px !important;
}
.head-program > h1 {
  font-size: 32px !important;
  font-weight: 600;
  color: #023047;
}
.div_email {
  margin-bottom: -60px !important;
}
.div_data_science {
  margin-top: 80px !important;
  z-index: 1;
  position: absolute;
}
.div_web {
  z-index: 1;
  position: absolute;
  margin-top: -70px !important;
  margin-right: 40px !important;
}
.procedures_2 > img {
  position: relative;
}
.div_password {
  margin-top: -35px !important;
  margin-right: 30px !important;
}
.form-label {
  color: #868b90 !important;
  font-size: 10px !important;
}
#exampleFormControlInput1,
#exampleFormControlInput2 {
  font-size: 11px !important;
}
.form-control {
  color: black;
}
.input_email > img {
  background-size: cover;
  height: 15px;
  width: 15px;
  align-items: center !important;
  margin: 7px 0 7px -25px;
}

/* === */
/* #main {
  width: 935px;
  margin: 0 auto;
  padding: 75px 100px 170px 100px !important;
  display: flex;
  flex-direction: column;
} */
#row3 {
  display: flex;
  flex-direction: row;
}
#info3 {
  flex: 50%;
  height: 244px;
  border: 1px solid rgba(255, 134, 93, 0.4);
  border-radius: 28px;
  padding-right: 40px;
  margin-top: 110px;
  margin-right: 80px;
}
#info3 h3 {
  margin-top: 30px;
  font-size: 28px;
  font-weight: 600;
  padding-left: 35px;
}
#info3 p {
  font-size: 16px;
  width: 450px;
  padding-left: 35px;
}
#ilustration3 {
  flex: 50%;
}
#ilustration3 img {
  position: absolute;
  height: 460px;
  width: 500px;
  object-fit: cover;
}
#ebanking {
  margin-top: 83px;
  margin-left: 5px;
  position: absolute;
  text-align: center;
  background-color: #f9ffe9;
  border-radius: 20px;
  width: 90px;
  height: 100px;
}
#ebanking div {
  padding: 18px 40px 40px 15px;
}
#ebanking img {
  width: 22px;
  height: 29px;
  object-fit: cover;
  padding: 5px;
  border-radius: 30px;
  background-color: #7cd11b;
}
#ebanking p {
  margin-top: 4px;
  text-align: center;
  font-family: "Hind Siliguri", sans-serif;
  color: #7cd11b;
  font-size: 14px;
  font-weight: 500;
}
#transfer {
  margin-top: 125px;
  margin-left: 370px;
  position: absolute;
  text-align: center;
  background-color: #eefcff;
  border-radius: 20px;
  width: 90px;
  height: 100px;
}
#transfer div {
  padding: 18px 40px 40px 15px;
}
#transfer img {
  width: 27px;
  height: 26px;
  object-fit: cover;
  padding: 5px;
  border-radius: 20px;
  background-color: #0883e0;
}
#transfer p {
  margin-top: 4px;
  text-align: center;
  font-family: "Hind Siliguri", sans-serif;
  color: #0883e0;
  font-size: 14px;
  font-weight: 500;
}
#datascience {
  position: relative;
  margin-top: 380px;
  margin-left: 87px;
  background-color: #ffffff;
  border-radius: 20px;
  width: 125px;
  height: 154px;
}
#datascience div {
  padding: 23px 0 40px 15px;
}
#datascience img {
  width: 20px;
  height: 28px;
  object-fit: cover;
  padding: 5px;
  border-radius: 20px;
  border: 1px solid #fcab97;
}
#datascience h5 {
  padding-left: 15px;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 700;
}
#datascience p {
  padding-left: 15px;
  width: 90px;
  margin-top: 0px;
  color: #656e87;
  font-size: 10px;
  font-weight: 500;
}
#webdev {
  position: absolute;
  margin-top: -153px;
  margin-left: 255px;
  background-color: #ffffff;
  border-radius: 20px;
  width: 125px;
  height: 154px;
}
#webdev div {
  padding: 23px 0 40px 15px;
}
#webdev img {
  width: 20px;
  height: 28px;
  object-fit: cover;
  padding: 5px;
  border-radius: 20px;
  border: 1px solid #fcab97;
}
#webdev h5 {
  padding-left: 15px;
  margin-top: 17px;
  font-size: 14px;
  font-weight: 700;
}
#webdev p {
  padding-left: 15px;
  width: 90px;
  margin-top: 0px;
  color: #656e87;
  font-size: 10px;
  font-weight: 500;
}
#row4 {
  display: flex;
  flex-direction: row;
}
#ilustration4 {
  flex: 50%;
  margin-right: 132px;
}
#ilustration4 img {
  height: 460px;
  width: 420px;
  object-fit: cover;
}
#info4 {
  flex: 50%;
  margin-top: 100px;
  height: 244px;
  border: 1px solid rgba(255, 134, 93, 0.4);
  border-radius: 28px;
  padding-right: 40px;
}
#info4 h3 {
  margin-top: 30px;
  font-size: 28px;
  font-weight: 600;
  padding-left: 35px;
}
#info4 p {
  font-size: 16px;
  width: 450px;
  padding-left: 35px;
}
hr {
  margin-left: 35px;
  margin-top: 40px;
}
p {
  text-align: justify;
}

@media only screen and (max-width: 1100px) {
  #info3 h3 {
    font-size: 28px;
    padding-left: 35px;
  }
  #info3 p {
    width: 350px;
    padding-left: 35px;
  }
  #ilustration3 {
    flex: 30%;
  }
  #ilustration3 img {
    margin-left: -15%;
    height: 360px;
    width: 400px;
    object-fit: cover;
  }
  #ebanking {
    margin-top: 50px;
    margin-left: -10%;
    position: absolute;
    text-align: center;
    background-color: #f9ffe9;
    border-radius: 20px;
    width: 70px;
    height: 80px;
  }
  #ebanking div {
    padding: 20px;
  }
  #ebanking img {
    width: 15px;
    height: 22px;
    object-fit: cover;
    padding: 4px;
  }
  #ebanking p {
    margin-top: 7px;
  }
  #transfer {
    margin-top: 100px;
    margin-left: 180px;
    border-radius: 20px;
    width: 70px;
    height: 80px;
  }
  #transfer div {
    padding: 15px;
  }
  #transfer img {
    width: 22px;
    height: 21px;
    object-fit: cover;
    padding: 5px;
  }
  #transfer p {
    margin-top: 15px;
    text-align: center;
  }
  #datascience {
    margin-top: 360px;
    margin-left: -15%;
    width: 100px;
    height: 129px;
  }
  #datascience div {
    padding: 25px;
  }
  #datascience img {
    width: 20px;
    height: 28px;
    object-fit: cover;
    padding: 5px;
  }
  #datascience h5 {
    margin-top: 15px;
  }
  #datascience p {
    margin-top: 0px;
  }
  #webdev {
    margin-top: -120px;
    margin-left: 100px;
    width: 100px;
    height: 129px;
  }
  #webdev div {
    padding: 15px;
  }
  #webdev img {
    width: 20px;
    height: 28px;
    object-fit: cover;
    padding: 5px;
  }
  #webdev h5 {
    padding-left: 0px;
    margin-top: 25px;
  }
  #webdev p {
    padding-left: 0px;
    margin-top: 0px;
  }
  #ilustration4 {
    margin-right: 0px;
  }
  #ilustration4 img {
    height: 400px;
    width: 360px;
    object-fit: cover;
  }
  #info4 {
    width: 370px;
  }
  #info4 h3 {
    margin-top: 25px;
    font-size: 24px;
  }
  #info4 p {
    font-size: 14px;
    width: 350px;
  }
}
@media only screen and (max-width: 770px) {
  #row3 , #row4 {
    flex-direction: column;
  }
  #info3 {
    position: absolute;
    display: block;
    margin-top: 570px;
  }
  #info3 h3 {
    font-size: 24px;
    margin-top: 30px;
  }
  #info3 p {
    font-size: 14px;
  }
  #ilustration3 img {
    position: relative;
  }
  #ebanking {
    margin-top: -300px;
    height: 100px;
  }
  #transfer {
    margin-top: -250px;
    margin-left: 230px;
    height: 100px;
  }
  #webdev {
    margin-top: 20px;
    margin-left: 0px;
  }
  #datascience {
    position: absolute;
    margin-top: 10px;
    margin-left: 100px;
  }
  #row4 {
    margin-top: 100%;
  }
}

@media only screen and (max-width: 610px) {
  #row3 {
    margin-left: 15%;
  }
  #info3 {
    margin-left: -10%;
  }
}

@media only screen and (max-width: 500px) {
  #row4 {
    margin-top: 120%;
  }
}

@media only screen and (max-width: 450px) {
  #row4 {
    margin-top: 140%;
  }
}

@media only screen and (max-width: 400px) {
  .div_regis,
  .div_kelas,
  #info3 p , #info3 h3,
  #info4 p , #info4 h3 {
    width: 200px;
  }
  #info3 {
    margin-top: 100%;
    height: 320px;
  }
  #info4 {
    margin-top: 10%;
    width: 235px;
  }
  .procedures_1 > img {
    margin-top: 50px;
  }
  .div_email {
     margin-top: 20px;
  }
  .div_password {
    margin-left: 200px  ;
    width: 220px;
  }
  .div_kelas {
    margin-top: 20px;
  }
  #ilustration3 img {
    margin-left: -5%;
    height: 250px;
    width: 225px;
    object-fit: cover;
  }
  #ebanking {
    margin-top: -180px;
    margin-left: -5%;
    position: absolute;
    text-align: center;
    background-color: #f9ffe9;
    border-radius: 20px;
    width: 40px;
    height: 46px;
  }
  #ebanking div {
    padding: 3px;
    height: 20px;
  }
  #ebanking p {
    padding-top: 0;
    font-size: 5px;
  }
  #ebanking img {
    width: 10px;
    height: 12px;
    object-fit: cover;
    padding: 3px;
  }
  #ebanking p {
    margin-top: 7px;
  }
  #transfer {
    margin-top: -50%;
    margin-left: 170px;
    border-radius: 20px;
    width: 40px;
    height: 46px;
  }
  #transfer div {
    padding: 3px;
  }
  #transfer img {
    width: 10px;
    height: 11px;
    object-fit: cover;
    padding: 2px;
  }
  #transfer p {
    font-size: 5px;
    margin-top: 0px;
  }
  #datascience {
    margin-top: -14%;
    margin-left: 15%;
    width: 50px;
    height: 65px;
  }
  #datascience div {
    padding: 5px;
  }
  #datascience img {
    margin-left: 5px;
    width: 10px;
    height: 14px;
    object-fit: cover;
    padding: 2px;
  }
  #datascience h5 {
    margin-top: -3px;
    margin-left: -5px;
    margin-bottom: 5px;
    font-size: 5px;
  }
  #datascience p {
    margin-left: -5px;
    width: 45px;
    font-size: 4px;
    margin-top: 0px;
  }
  #webdev {
    margin-top: -14%;
    margin-left: 35%;
    width: 50px;
    height: 65px;
  }
  #webdev div {
    padding: 5px;
  }
  #webdev img {
    margin-left: 5px;
    width: 10px;
    height: 14px;
    object-fit: cover;
    padding: 2px;
  }
  #webdev h5 {
    margin-top: -3px;
    margin-left: 10px;
    margin-bottom: 5px;
    font-size: 5px;
  }
  #webdev p {
    margin-left: 10px;
    width: 20px;
    font-size: 4px;
    margin-top: 0px;
  }
  #ilustration4 img {
    height: 250px;
    width: 225px;
    object-fit: cover;
  }

  .div_regis > h1,
  .div_kelas > h1 {
    font-size: 28px !important;
    font-weight: 600;
    color: #023047;
  }
  .div_regis > p,
  .div_kelas > p {
    font-size: 16px !important;
  }
  .div_data_science {
    background: #feecd7;
    width: 162px !important;
  }
  .div_web {
    background: #f9ffe9;
    width: 192px !important;
  }
  .div_data_science > img,
  .div_web > img {
    height: 40px !important;
    align-items: center;
  }
  .div_content_data_science > p,
  .div_content_web > p {
    font-size: 12px !important;
    margin-bottom: -7px !important
    ;
  }
  .div_content_data_science > a {
    font-size: 10px !important;
    color: #ff865d;
  }
  .div_content_web > a {
    font-size: 10px !important;
    color: #7cd11b;
  }
  .procedures {
    background-image: url("../assets/background-procedures.png");
  }
  .procedures_1 > img {
    width: 372px !important;
  }
  .procedures_2 > img {
    width: 471px !important;
  }
  .head-program > h1 {
    font-size: 32px !important;
    font-weight: 600;
    color: #023047;
  }
  .div_email {
    margin-bottom: -60px !important;
  }
  .div_data_science {
    margin-top: 80px !important;
    z-index: 1;
    position: absolute;
  }
  .div_web {
    z-index: 1;
    position: absolute;
    margin-top: -70px !important;
    margin-right: 40px !important;
  }
  .procedures_2 > img {
    position: relative;
  }
  .div_password {
    margin-top: -35px !important;
    margin-right: 30px !important;
  }
  .form-label {
    color: #868b90 !important;
    font-size: 10px !important;
  }
  #exampleFormControlInput1,
  #exampleFormControlInput2 {
    font-size: 11px !important;
  }
  .form-control {
    color: black;
  }
  .input_email > img {
    background-size: cover;
    height: 15px;
    width: 15px;
    align-items: center !important;
    margin: 7px 0 7px -25px;
  }
  .procedures {
    margin-top: -30%;
  }
  #row4 {
    margin-top: 160%;
  }
}

</style>
